import { messages, messageTemplates } from '../../../../common/sdk/messages';

class NilAssignmentError extends Error {
  constructor(params: Parameters<typeof messages.nilAssignmentMessage>[0]) {
    const message = messages.nilAssignmentMessage(params);
    super(message);
    this.name = 'NilAssignmentError';
    this.message = message;
  }
}

class UnsupportedLinkTypeError extends Error {
  constructor(params: Parameters<typeof messages.unsupportedLinkType>[0]) {
    const message = messages.unsupportedLinkType(params);
    super(message);
    this.name = 'UnsupportedLinkTypeError';
    this.message = message;
  }
}

export class InvalidLabelError extends NilAssignmentError {
  constructor(index: number) {
    super({
      functionName: 'menuItems',
      propertyName: 'label',
      index,
    });
    this.name = 'InvalidLabelError';
  }
}

export class InvalidIdPatternError extends Error {
  constructor({
    index,
    label,
    id,
  }: {
    index: number;
    label: string;
    id: string;
  }) {
    super(
      messageTemplates.error_menu_items_id_pattern({
        index,
        label,
        id,
      }),
    );
    this.name = 'InvalidIdPatternError';
  }
}

export class NonUniqueIdError extends Error {
  constructor({ id }: { id: string }) {
    super(messageTemplates.error_menu_items_id_uniqueness({ id }));
    this.name = 'NonUniqueIdError';
  }
}

export class InvalidTargetError extends Error {
  constructor({
    index,
    label,
    target,
  }: {
    index: number;
    label: string;
    target: string;
  }) {
    super(
      messageTemplates.error_menu_items_target({
        index,
        label,
        target,
      }),
    );
    this.name = 'InvalidTargetError';
  }
}

export class InvalidMenuDepthError extends Error {
  constructor(maxLevels: number, labelValue: string) {
    super(
      messageTemplates.error_menu_items_depth({
        labelValue,
        maxLevels,
      }),
    );
    this.name = 'InvalidMenuDepth';
  }
}

export class LinkTypeError extends UnsupportedLinkTypeError {
  constructor(wrongValue: string, index: number) {
    super({
      functionName: 'menuItems',
      propertyName: 'link',
      wrongValue,
      index,
    });
  }
}
